








































import { Component, Vue, Prop } from "vue-property-decorator";
import { PostExpertZzq, PostExpertZzty } from "@/request/dig";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../components/left-nav.vue";
import ResultFilterCmp from "../../../components/result-filter-cmp.vue";
import Result from "./bianzheng-result.vue";
import Waiting from "../../../components/waiting.vue";
import Copy from "@/components/copy.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
    ResultFilterCmp,
    Result,
    Waiting,
    Copy
  }
})
export default class DigExpertBianzheng extends Vue {
  private message: any = {
    project_id: "",
    table_id: "",
    分析名称: "症状群",
    中医证型: "全部"
  };
  private result: any = {
    症状统计详情: ""
  };
  private ifGotResult: boolean = false;
  private cFenxi: any = "症状群";
  /**
   * @description 重新回到等待状态
   */
  private reWait() {
    this.ifGotResult = false;
  }
  /**
   * @description 重置条件
   */
  private resetMessage(type) {
    this.cFenxi = type;
    if (type === "症状群") {
      this.message["分析名称"] = "症状群";
      this.message["中医证型"] = "全部";
    } else if (type === "症状特异性分析") {
      this.message["分析名称"] = "症状特异性分析";
    }
  }
  /**
   * @description 切换当前分析方法
   */
  private typeChange(type) {
    this.resetMessage(type);
    this.analysis();
  }
  /**
   * @description 切换当前分析方法
   */
  private zyzxChange(value) {
    this.message["中医证型"] = value;
    this.analysis();
  }
  /**
   * @description 开始分析
   */
  private analysis() {
    this.ifGotResult = false;
    const load = this.$loading({
      text: "分析中...请稍后"
    });
    const params: any = this.message;
    if (this.cFenxi === "症状群") {
      PostExpertZzq(this, params)
        .then((data: any) => {
          this.result = data;
          this.ifGotResult = true;
        })
        .catch(() => {
          this.resetMessage(this.cFenxi);
        })
        .finally(() => {
          load.close();
        });
    } else if (this.cFenxi === "症状特异性分析") {
      PostExpertZzty(this, params)
        .then((data: any) => {
          this.result = data;
          this.ifGotResult = true;
        })
        .catch(() => {
          this.resetMessage(this.cFenxi);
        })
        .finally(() => {
          load.close();
        });
    }
  }
}
